import React from "react";
import { Box } from "@material-ui/core";
import { get } from "lodash";
import ProgressBar from "../../../widgets/ProgressBar";
import { STATUS } from "../../../../constants";

const CheckinStatus = colProps => {
  const completedUsers = get(colProps, "dataItem.usercheckin.items", []).filter(i => get(i,"checkInStatus","") === 'COMPLETE')
  const overDueUsers = get(colProps, "dataItem.usercheckin.items", []).filter(i => get(i,"checkInStatus","") === 'OVERDUE')
  const checkinDisplayStatus = overDueUsers.length ? STATUS["OVERDUE"] : completedUsers.length ? STATUS["COMPLETE"] : STATUS["INPROGRESS"]
  const progressValue = completedUsers.length / get(colProps, "dataItem.usercheckin.items", []).length
  return (
    <td>
      <Box display="flex" mb={1}>
        <span>{checkinDisplayStatus}</span>
        <span className="f-gray font-12 ml10">
          {`${completedUsers.length}/${get(colProps, "dataItem.usercheckin.items", []).length}`}
        </span>
      </Box>
      <ProgressBar
        value={progressValue}
        status={checkinDisplayStatus}
      />
    </td>
  );
};

export default CheckinStatus;
